var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',[_vm._v(" "+_vm._s(_vm.fmtNumeral(_vm.value).format('$0,0.00a'))+" "),_c('span',{class:{
      'text-success': _vm.diff > 0,
      'text-danger': _vm.diff < 0,
    },attrs:{"id":`${_vm.prefix}-${_vm.widgetKey}-${_vm.index}`}},[_c('sup',[_vm._v(" "+_vm._s(_vm.diff > 0 ? '▴' : '▾')+" "+_vm._s(_vm._f("numeral")(_vm.diff,'0%'))+" ")])]),_c('b-tooltip',{attrs:{"target":`${_vm.prefix}-${_vm.widgetKey}-${_vm.index}`,"triggers":"hover"}},[_vm._v(" Last year: "+_vm._s(_vm.fmtNumeral(_vm.lastYearValue).format('$0,0.00a'))+" ")])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }